<template>
  <div class="critical-hit-box" v-show="visible" @click="closeDialog">
    <div class="mask"></div>
    <div class="main" @click.stop>
      <img
        class="img-close"
        src="../images/hitbox-close.png"
        alt=""
        @click="closeDialog"
      />
      <div class="times">{{ times }}/20</div>
      <div class="progress-box">
        <div
          class="value"
          :style="{ height: ((20 - times) / 20) * 90 + 'px' }"
        ></div>
      </div>
      <div class="amount">剩餘{{ amount }}個</div>
      <img
        class="img-hitbox"
        src="../images/hitbox.png"
        alt=""
        v-show="!drawLoading"
      />
      <div class="video-hitbox">
        <vap-video
          ref="VapVideo"
          @video-ended="showDrawResult()"
          @play="openBox()"
        ></vap-video>
      </div>

      <div class="price">{{ paymentAmount }}鑽石/1次</div>
      <img
        class="img-button"
        :class="{ active: isClick }"
        src="../images/hitbox-button.png"
        alt=""
        @click="handleOpenBox()"
      />
    </div>
  </div>
</template>
<script>
import { getPackSack, sendGift } from '@/api/voice-room';
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';
import VapVideo from '@/components/VapVideo';
import { mapGetters } from 'vuex';

export default {
  name: 'CriticalHit',
  components: {
    'vap-video': VapVideo
  },
  props: {},
  data() {
    return {
      amount: 0, // 寶箱數量
      times: 0, // 開寶箱次數
      visible: false,
      paymentAmount: 1288, // 開寶箱價格
      loading: false,
      drawLoading: false,
      drawResult: null,
      isClick: false
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['accountInfo', 'userInfo']),

    diamondBalance() {
      return this.accountInfo ? this.accountInfo.diamondBalance || 0 : 0;
    },
    balance() {
      return this.accountInfo ? this.accountInfo.balance || 0 : 0;
    }
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    async show() {
      await this.init();
      this.visible = true;
    },
    async init() {
      await this.getTimes();
      await this.getPackSack();
    },
    async getTimes() {
      const { data } = await this.$http.get('/voiceRoom/getBoxNum999');
      this.times = data;
    },
    async getPackSack() {
      const { data } = await getPackSack();
      const detail = data.find(item => item.name === '鑽石寶箱');
      if (detail) {
        this.amount = detail.num;
      }
    },
    handleOpenBox() {
      if (!this.amount) {
        this.$confirm({
          content: `鑽石寶箱不足`,
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          // cancelButtonText: '取消',
          closeOnClickOverlay: true
        });
        return;
      }
      this.isClick = true;
      setTimeout(() => {
        this.isClick = false;
      }, 800);
      if (this.loading) {
        return;
      }
      if (this.paymentAmount > this.diamondBalance) {
        const coinPrice = Math.ceil(
          (this.paymentAmount - this.diamondBalance) / 15
        );
        if (this.balance - coinPrice >= 0) {
          this.$confirm({
            content: `鑽石不足，是否花費${coinPrice}nicee幣購買鑽石`,
            title: '提示',
            showCancelButton: false,
            confirmButtonText: '確定',
            // cancelButtonText: '取消',
            closeOnClickOverlay: true
          }).then(async () => {
            try {
              this.loading = true;
              await this.$http.post('/account/convertAccount', {
                accountKind: 'Balance',
                convertAccountKind: 'Diamond',
                convertAmount: coinPrice,
                userUuid: this.uuid
              });
              this.$store.dispatch('app/getUserAccount');
              this.startDraw();
            } catch (error) {
              this.$message.error('購買失敗');
              this.loading = false;
            }
          });
        } else {
          this.$confirm({
            content: `餘額不足，是否去儲值`,
            title: '提示',
            showCancelButton: false,
            confirmButtonText: '確定',
            // cancelButtonText: '取消',
            closeOnClickOverlay: true
          }).then(() => {
            window.open('/diamond-recharge', '_blank');
          });
        }
      } else {
        this.loading = true;
        this.startDraw();
      }
    },
    startDraw() {
      this.drawLoading = true;
      this.$refs['VapVideo'].init(
        'https://resource.funplus.social/voice-room/unboxing-animation.mp4'
        // 'https://resource.funplus.social/test/video.mp4'
      );
    },
    async openBox() {
      try {
        const params = {
          playerUserUuid: this.userInfo ? this.userInfo.uuid : '',
          roomUid: VoiceRoomIM.groupID,
          boxFrom: 'pack',
          count: 1,
          giftId: 101,
          optionalToUuidList: []
        };

        const { data } = await sendGift(params);
        this.$store.dispatch('app/getUserAccount');
        this.times = this.times == 19 ? 0 : Number(this.times) + 1;
        await this.init();
        this.loading = false;
        this.drawResult = data;
      } catch (error) {
        this.loading = false;
        this.drawResult = null;
        this.$message.error('開寶箱失敗');
      }
    },
    showDrawResult() {
      this.drawLoading = false;
      if (!this.loading) {
        if (
          this.drawResult &&
          this.drawResult.boxGiftLst &&
          this.drawResult.boxGiftLst.length
        ) {
          const boxGiftLst = this.drawResult.boxGiftLst;
          boxGiftLst.sort((a, b) => {
            if (a.boxName === '鑽石寶箱') {
              return -1;
            }
            if (b.boxName === '鑽石寶箱') {
              return 1;
            }
            return b.boxPayAmount - a.boxPayAmount;
          });
          let drawName = '';
          boxGiftLst.forEach(item => {
            drawName = `${drawName}<div class="draw-result-item"><img class="draw-result-icon" src="${
              item.boxImageUrl
            }">${item.boxName}${
              item.boxPayAmount ? '(' + item.boxPayAmount + '鑽)' : ''
            }*${item.orderNum}</div>`;
          });
          this.$confirm({
            content: `
          ${drawName}
          `,
            title:
              this.times == 0 ? '恭喜你產生了暴擊，獲得了' : '恭喜你開出了',
            showCancelButton: false,
            confirmButtonText: '確定',
            closeOnClickOverlay: true,
            dangerouslyUseHTMLString: true
          });
          this.drawResult = null;
        }
      } else {
        setTimeout(() => {
          this.showDrawResult();
        }, 100);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.critical-hit-box {
  position: absolute;
  left: 0;
  top: 0;
  font-size: 14px;
  width: 100%;
  height: 100%;
  color: #fffaba;
  border-radius: 20px;
}
.mask {
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  z-index: 10;
}
.main {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 360px;
  height: 406px;
  z-index: 11;
  background: url('../images/hitbox-bg.png') no-repeat center top;
  background-size: 100% auto;
  font-size: 12px;
  .img-close {
    position: absolute;
    width: 29px;
    height: auto;
    top: 38px;
    left: 24px;
    z-index: 2;
  }
  .progress-box {
    background: linear-gradient(#7b94f4, #ff38ff);
    // background-color: #a63f17;
    border-radius: 0px 0px 4px 4px;
    width: 5px;
    height: 90px;
    position: absolute;
    top: 139px;
    left: 32px;
    overflow: hidden;
    .value {
      background-color: #a63f17;
      // border-radius: 0px 0px 4px 4px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
    }
  }
  .amount {
    position: absolute;
    top: 124px;
    right: 23px;
  }
  .times {
    position: absolute;
    top: 233px;
    left: 20px;
  }
  .img-hitbox {
    width: 213px;
    height: auto;
    position: absolute;
    left: 25%;
    top: 20%;
  }
  .video-hitbox {
    width: 100%;
    height: 100%;
    position: absolute;
    top: -2%;
    // overflow: hidden;
  }
  .price {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 22%;
  }
  .img-button {
    width: 176px;
    position: absolute;
    left: 25%;
    bottom: 5%;
    cursor: pointer;
    transition: transform 0.3s ease;
    &.active {
      transform: scale(0.95);
    }
  }
}
</style>
<style lang="scss">
.el-message-box {
  .draw-result-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .draw-result-icon {
    width: 50px;
    margin-right: 4px;
  }
}
</style>
